<template>
    <div class="lottie-bg">
        <div id="lottie" class="loading-img-wrap">
            <img src="@assets/images/live-logo.gif" rel="preload" style="width: 100%" />
        </div>
        <!-- <div class="a" @click="toBindMobile()">去绑定</div> -->
    </div>
</template>
<script>
import { auth } from "@libs/wechat";
import cookie from "@utils/store/cookie";
import store from "@/store";

const STATE_KEY = "wx_authorize_state";
const WX_AUTH = "wx_auth";
const BACK_URL = "login_back_url";
const LOGINTYPE = "loginType";

export default {
    name: "Auth",
    mounted() {
        const { code, state } = this.$route.query;
        console.log("【Auth页面】接收到授权回调:", { code: code ? code.substring(0, 10) + '...' : null, state });
        this.authLogin(code, state);
    },
    methods: {
        async authLogin(code, state) {
            console.log("【Auth页面】开始处理授权登录:", { code: code ? code.substring(0, 10) + '...' : null, state });
            try {
                let res = await auth(code, state);
                console.log("【Auth页面】授权接口返回:", { status: res.status, hasData: !!res.data });
                
                if (res.status == 200) {
                    var data = res.data;
                    let expires_time = data.expires_time.substring(0, 19);
                    expires_time = expires_time.replace(/-/g, "/");
                    expires_time = new Date(expires_time).getTime() - 28800000;
                    const datas = {
                        token: data.token,
                        expires_time: expires_time,
                    };
                    
                    console.log("【Auth页面】保存授权信息:", {
                        hasToken: !!data.token,
                        expiresTime: new Date(expires_time).toLocaleString(),
                        hasMobile: data.has_mobile
                    });
                    
                    this.$store.commit("LOGIN", datas);
                    localStorage.setItem('baoshi_user_token', data.token);
                    localStorage.setItem(WX_AUTH, code);
                    localStorage.removeItem(STATE_KEY);
                    localStorage.setItem("USERINFO", JSON.stringify(data.userinfo));
                    // loginType && localStorage.removeItem(LOGINTYPE);
                    // location.replace("/");

                    if (data.has_mobile != 1) {
                        console.log("【Auth页面】用户未绑定手机号，跳转绑定页面");
                        return this.toBindMobile();
                    }

                    let historyRouter = localStorage.getItem("historyRouter") || "";
                    let historyAppShareLink = localStorage.getItem("historyAppShareLink") || "";
                    
                    console.log("【Auth页面】准备跳转:", { historyRouter, historyAppShareLink });
                    
                    if (historyRouter) {
                        if (historyRouter.indexOf("auth") != -1) {
                            console.log("【Auth页面】跳转到首页");
                            location.replace("/");
                        } else {
                            console.log("【Auth页面】跳转到历史路由:", historyRouter);
                            location.replace(historyRouter);
                        }
                    } else {
                        if (historyAppShareLink) {
                            console.log("【Auth页面】跳转到分享链接:", historyAppShareLink);
                            location.replace(historyAppShareLink);
                        } else {
                            console.log("【Auth页面】跳转到首页");
                            location.replace("/");
                        }
                    }
                }
            } catch (error) {
                console.error("【Auth页面】授权失败:", error);
                this.$dialog.toast({ mes: '授权失败，请重试' });
                // location.replace("/login");
            }
        },

        toBindMobile() {
            console.log("【Auth页面】跳转到绑定手机号页面");
            location.replace("/login_wechat");
        }
    },
};
</script>
<style scoped>
.lottie-bg {
    position: fixed;
    left: 0;
    top: 0;
    background-color: #fff;
    width: 100%;
    height: 100%;
    z-index: 999;
    display: -webkit-flex;
    display: flex;
    -webkit-align-items: center;
    align-items: center;
    -webkit-justify-content: center;
    justify-content: center;
}

#lottie {
    width: 35%;
    display: block;
    overflow: hidden;
    transform: translate3d(0, 0, 0);
    margin: auto;
}
</style>